/**
 * AUTOGENERATED FILE. DO NOT EDIT.
 *
 * This file is generated by running yarn i18n:build, do not edit it manually.
 *
 * If you wish to update it, please run yarn i18n:build.
 */
/* eslint-disable no-restricted-imports */
import {i18n} from "@lingui/core";
import * as React from "react";

import {RequestInfo} from "@repo/shared-core";

// We statically import the English strings as we use them as a fallback
// for locales that don't have any translations. Additionally, it improves
// the performance of the English site by not having to load the strings at
// runtime.
// NOTE(john): This is replaced with the actual English strings in the build
// process.
const enStrings = {"oZyG4C":["Continue with Google"],"Tk3V+k":["Logging you in..."],"Kzy2d8":["More Info"],"sW5OjU":["required"],"LLAa/9":["Optional"],"y5p2bQ":["Did you know?"],"XnGvPC":["Regardless of who you are, mastering even just one more skill on Khan Academy results in learning gains."],"I4wbpi":["Learners have spent ",["actualMinutes"]," billion minutes learning on Khan Academy. ",["approxMinutes"]," billion minutes is equivalent to ",["actualYears"]," years."],"aIXCVN":["Your browser blocked a popup window required for logging in. Please click on the new Continue with Google button and try logging in again."],"JbFmLD":["Your browser blocked third-party cookies required for logging in. Please change your browser settings to allow cookies on khanacademy.org."],"zn1Xmb":["You closed the popup window before logging in. If that was a mistake, try logging in again."],"Yb2vtw":["You are currently logged in to another Google account. Please log out of that account and try again."],"1x3wHL":["Your invitation was not found. Please try clicking the link in your email again."],"yl7Nu2":["Oops! Something went wrong. Please try again."],"Xo7rk9":["Your browser blocked a popup window required for logging in. Please change your browser settings to allow popups from khanacademy.org."],"mALQCE":["Oops. Something went wrong. Please try again."],"X7283E":["Quiz ",["0"]],"rcXik1":["Quiz"],"LxT/yl":["Unit test"],"ox6SCQ":["Try an Hour of Code™<0/>with Khan Academy"],"9SVlc9":["Start coding now"],"gHpTtF":["Teachers, start here"],"mNcBqU":["Parents, start here"],"DwuoH0":["Facebook"],"0F2sI+":["Twitter"],"O3oNi5":["Email"],"k0nGE6":["penguin: A project from Hour of Code last year, courtesy of Lydia."],"SLzMFe":["An illustration of a webpage about holidays"],"M2oc/B":["An illustration of a computer database"],"yuJ1pS":["Jump to: Many ways to do Hour of Code"],"qk3dLh":["We have many ways to do Hour of Code at Khan Academy."],"j7hi6m":["Hour of Drawing with Code"],"vmek/3":["Learn how to program drawings using JavaScript by designing your very own snowman."],"QcNWql":["Start drawing with code"],"Fsr7Yy":["Hour of Webpages"],"IvCoDZ":["Learn how to make webpages with HTML tags and CSS, finishing up by making your very own greeting card."],"BdtawD":["Start creating webpages"],"3rS1zQ":["Hour of Databases"],"g+KlQD":["Like playing with data? Learn how to manipulate data in a database and make your own custom store."],"MpAT7Y":["Start creating databases"],"NJCwIo":["“I have to admit that I was nervous about trying it, since I know nothing about coding...All of my students from grades 6-12 participated in the Hour of Code...Everyone loved it.”"],"HPbgg0":["Mrs. Cassidy"],"Ja6Tpj":["6-12 Science Teacher"],"T88SL1":["Hour of code in your classroom"],"cqxUSQ":["The Hour of Code is a global movement by Computer Science Education Week and Code.org reaching tens of millions of students in 180+ countries through a one-hour introduction to computer science and computer programming. Learn about the simple steps you can take to prepare your class for an Hour of Code."],"3sIJUr":["Go beyond the hour"],"bdQkSm":["More JavaScript: Drawing and Animation"],"0abh5D":["Learn how to use variables, make animations, store your data in arrays and objects, group your code into functions, and more!"],"zwWKhA":["Learn more"],"NPZo2T":["More HTML/CSS: Making Webpages"],"UGbEoM":["Learn more tags like links and tables, then learn more powerful css selectors and properties to completely re-style your page."],"ZNAE9I":["More SQL: Querying and managing data"],"lcaGET":["Learn more advanced ways to filter data, plus how to update data and combine data from multiple tables."],"LyH5DB":["Start your hour today"],"zJKtzt":["Hour of Code on Khan Academy"],"g5Swf8":["Anyone can learn to code! Spend an hour on Khan Academy learning to code, with our tutorials in JS, HTML, or SQL."]};

let results: Record<string, string | string[]> | undefined = undefined;
let promise: Promise<void> | null = null;

// We keep track of locales that are missing translations so we can load the
// English strings for those locales.
// NOTE(john): This array is replaced with the list of locales.
const missingTranslations: string[] = ["ur","zh-hant","sgn-us","is","en-x-rtl","zu","xh","th","te","sw","fa","ms","he","fa-af","sq"];

// We keep track of locales that have been bundled together in the same file
// so we can load them all at once.
const extraLocales: string[] = ["uk","pa","or","km","ta","sk","rw","mn","lol","ky","it","fv","ar"];

/**
 * Load the i18n strings for the current locale and add them to the Lingui i18n
 * instance. This uses Suspsense so you'll want to make sure that your
 * component is wrapped in a Suspense (for loading) and an ErrorBoundary
 * (for errors).
 *
 * This function is called by the LoadStrings component, which is a Loadable
 * component that loads the strings for a route and all descendant imports.
 *
 * You can use this directly or you can use the withStrings HoC to load
 * strings for a component.
 */
export const useStrings = () => {
    if (results) {
        return results;
    }

    const locale = RequestInfo.kaLocale;

    // If the locale is English, or doesn't have any translations, we don't need to load
    // any additional strings.
    if (locale === "en" || missingTranslations.includes(locale)) {
        // Load the English strings into Lingui. This serves as a fallback for
        // locales that don't have any translations (and the actual strings for the English
        // locale).
        results = enStrings;
        i18n.load(locale, results);
        return results;
    }

    if (!promise) {
        promise = (async () => {
            const locale = RequestInfo.kaLocale;
            const localeFile = extraLocales.includes(locale) ? "extra" : locale;

            if (process.env.NODE_ENV === "production") {
                const result = (await import(`./lingui/${localeFile}.json`))
                    .default;
                results = localeFile === "extra" ? result[locale] : result;
            } else {
                results = {};
            }

            // Load the strings into Lingui
            i18n.load(locale, {...enStrings, ...results});

            promise = null;
        })();
    }

    throw promise;
};

/**
 * The HOC to load i18n strings for a route and all descendant imports.
 *
 * Examples:
 *
 * - export default withStrings(WrappedComponent);
 *
 * - export default compose(
 *      withStrings,
 *      withRouter
 *   )(WrappedComponent);
 */
export const withStrings = <C extends object>(
    WrappedComponent: React.ComponentType<C>,
) => {
    if (process.env.NODE_ENV === "test") {
        return WrappedComponent;
    }

    // Try to create a nice displayName for React Dev Tools.
    const displayName =
        WrappedComponent.displayName || WrappedComponent.name || "Component";

    // Creating the inner component.
    const WrapperComponent = (props: C): React.ReactNode => {
        useStrings();
        return <WrappedComponent {...(props as C)} />;
    };

    WrapperComponent.displayName = `withStrings(${displayName})`;

    return WrapperComponent;
};
